import { CSSObject } from "@emotion/react";
import { constants, cssVariableStyles } from "@newsela/angelou";

const status = constants.colors.status;
const red = status.danger[700];
const redIcon = cssVariableStyles.generateIconColorCss({
  primaryColor: red,
});

export const bodyStyles: CSSObject = {
  padding: "14px 20px",
};

export const errorAIIconStyles: CSSObject = {
  marginTop: "-6px",
  marginRight: "6px",
  verticalAlign: "middle",
  ...redIcon,
};

export const translatedTextStyles = (isError: boolean): CSSObject => ({
  "&&&&": {
    margin: "0",
    lineHeight: "150%",
    fontSize: "16px",
    ...(isError ? { color: red } : {}),
  },
});
